function AlignRightIcon()
{
    return (
        <svg width="80%" height="80%" viewBox="0 0 24 24" fill="none">
<line x1="21" y1="6" x2="3" y2="6" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<line x1="21" y1="10" x2="7" y2="10" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<line x1="21" y1="14" x2="3" y2="14" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<line x1="21" y1="18" x2="7" y2="18" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
    )
}

export default AlignRightIcon